// import { analyticsEvent } from '../analytics';
import AbstractController from '../dom/controllers/abstractController';
import GameModel from '../game/models/gameModel';
import GameController from '../game/controllers/gameController';
import { ee } from '../eventEmitter';
import gameSettings from '../game/constants/gameSettings';
import gameStatuses from '../game/constants/gameStatuses';
import eventsForListening from '../dom/constants/eventsForListening';
import AppAuthController from './appAuthController';
import ApiController from '../api/apiController';
import AppViewController from './appViewController';
import AppFormsController from './appFormsController';
import { screenNames } from './constants/screens';
import { authEvents } from './constants/authEvents';
import { otherEvents } from './constants/otherEvents';
import AppCookiePlate from './appCookiePlate';
import Leaderboard from './components/leaderboard';
import FinishFlagView from '../game/views/finishFlagView';
import Analytics from '../analytics';
import { generateLevelLootableObjects } from '../game/helpers/gameLevel';
import { waitForTimeoutPromise } from '../utils/waitForTimeoutPromise';

const GAME_IN_DEMO_MODE = true;
const GAME_BLOCKED = false;

const passwordChangeUrlParams = {
    token: 'password-reset-token',
    email: 'email'
};
// const initialActiveBg = bgNames.INTRO;

const keydownKeyCodes = {
    enter: 13, // 'Enter',
    space: 32 // 'Backspace'
};

export default class AppMVC {
    gameModel;
    #authController;
    #apiController;
    #viewController;
    #formsController;
    #cookiePlate;
    #gameSessionId;
    #htmlReady = false;
    #finishScreenTimeout;
    #finishFlagView;

    #hideClassName = 'hide';
    #initialActiveScreen = screenNames.INTRO;

    #preloaderEl;
    #pauseEnabled = false;

    #buttons = [];
    #onButtonClickHandler;

    #buttonsControllers;
    #keyboardController;
    #keydownHandler;

    // pause
    #pausePage;

    #gameCounterEl;
    #gameCounterWrapper;

    #audioEl;
    #audioToggleEl;
    #audioPausedByUser = false;

    #leaderboard;

    // for MVC
    #paused;

    constructor() {
        Analytics.initOnClickEvents();

        this.startListenEE();
        this.initComponents();
        this.checkIsUserLogged();
        this.checkPasswordChange();

        // this.addDevShortcuts();
        // this.#apiController.fetchLeaderboard();
        // this.#finishFlagView.show(this.#viewController.isPt);
        // this.testLeaderboard();
        // this.logGameData(6083);
    }

    async logGameData(id) {
        const response = await this.#apiController.getGameSessionData(id);

        const data = response.data[0].game;

        const levelConfig = data.game_data;

        const levelConfigSummary = levelConfig.reduce((acc, entry) => {
            const { option } = entry;

            if (!acc[option]) {
                acc[option] = 1;
            } else {
                acc[option] += 1;
            }

            return acc;
        }, {});

        console.log(data);
        console.log(levelConfigSummary);
        console.log(`TOTAL ITEMS: ${levelConfig.length}`);
        console.log(`GOOD ITEMS TOTAL: ${levelConfigSummary.good}`);

        const logs = JSON.parse(data.logs);
        // let isSuspicious = false;
        let lastEntryTime = null;

        const logsSummary = logs.reduce((acc, entry) => {
            const { type } = entry;

            if (!acc[type]) {
                acc[type] = 1;
            } else {
                acc[type] += 1;
            }

            if (lastEntryTime) {
                const timeDiff = entry.time - lastEntryTime;
                const isSuspicious = timeDiff > 5;

                if (isSuspicious) {
                    console.log(
                        `Suspicious time diff of ${timeDiff} detected!`
                    );
                }
            }

            lastEntryTime = entry.time;

            return acc;
        }, {});

        console.log(logsSummary);
    }

    addDevShortcuts() {
        if (window.location.hash === '#skip-auth') {
            setTimeout(() => {
                this.toStartGame();
            }, 3000);
        }

        document.getElementById('introTitle').addEventListener('click', () => {
            this.toStartGame();
        });
    }

    async checkIsUserLogged() {
        await this.#authController.getIsUserLogged();

        this.#viewController.isGuest = this.#authController.isGuest;
        Analytics.isGuest = this.#authController.isGuest;
        this.toInitGame();
    }

    // eslint-disable-next-line class-methods-use-this
    checkPasswordChange() {
        const urlParams = new URLSearchParams(window.location.search);

        const passwordChangeToken = urlParams.get(
            passwordChangeUrlParams.token
        );
        const passwordChangeEmail = urlParams.get(
            passwordChangeUrlParams.email
        );

        if (
            typeof passwordChangeToken === 'string'
            && typeof passwordChangeEmail === 'string'
        ) {
            this.#authController.passwordChangeParams = {
                'password-reset-token': passwordChangeToken,
                email: passwordChangeEmail
            };
            this.#initialActiveScreen = screenNames.SET_NEW_PASSWORD;
        }
    }

    initComponents() {
        this.#viewController = new AppViewController({ isDemoMode: GAME_IN_DEMO_MODE });
        this.#apiController = new ApiController();
        this.#authController = new AppAuthController({ isDemoMode: GAME_IN_DEMO_MODE });
        this.#cookiePlate = new AppCookiePlate();
        this.#formsController = new AppFormsController();
        this.#leaderboard = new Leaderboard(
            document.querySelector('#results-leaderboard')
        );
        this.#finishFlagView = new FinishFlagView('#game-finish-flag', {
            hideOnComplete: this.#viewController.isPt
        });
    }

    startListenEE() {
        ee.on('htmlLoaded', async () => {
            this.getHtmlEls();
            this.toInitGame();
        });

        ee.on('loadDone', this.loadDone.bind(this));
        ee.on('gameLevelComplete', this.handleLevelComplete.bind(this));
        ee.on('showFinishPage', this.showFinishPage.bind(this));
        ee.on('timerClick', () => {
            if (!this.#finishScreenTimeout) return;
            this.showResults();
        });

        // События авторизации
        ee.on(authEvents.LOGIN, () => {
            this.#viewController.isGuest = this.#authController.isGuest;
            Analytics.isGuest = this.#authController.isGuest;
            this.#viewController.setActiveScreen(screenNames.RULES);
            this.toInitGame();
        });
        ee.on(authEvents.UPDATE_USER_DATA, (data) => {
            this.#viewController.updateUserData(data);
        });
        ee.on(authEvents.LOGOUT, () => {
            this.#viewController.isGuest = this.#authController.isGuest;
            Analytics.isGuest = this.#authController.isGuest;
            this.#viewController.setActiveScreen(screenNames.INTRO);
        });
        ee.on(authEvents.REGISTER, () => {
            this.#viewController.isGuest = this.#authController.isGuest;
            Analytics.isGuest = this.#authController.isGuest;
            this.#viewController.setActiveScreen(screenNames.RULES);
            this.toInitGame();
        });
        ee.on(otherEvents.COOKIE_POLICY_ACCEPT, () => {
            this.#viewController.onCookieAccept();
        });
    }

    getHtmlEls() {
        this.getPreloader();
        this.createKeyboardController();
        this.getGameCounter();
        this.getAudio();
        this.initButtons();

        this.#htmlReady = true;
    }

    getPreloader() {
        this.#preloaderEl = document.getElementById('preloader');
    }

    initButtons() {
        this.#audioToggleEl.addEventListener(
            'click',
            this.toggleAudio.bind(this)
        );
        this.#onButtonClickHandler = this.onButtonClick.bind(this);
        this.#buttons = Array.from(
            document.getElementsByClassName('js-control-button')
        );

        this.#buttonsControllers = new AbstractController(this.#buttons, [
            {
                events: ['click'],
                functionForEvents: this.#onButtonClickHandler
            }
        ]);
        this.#buttonsControllers.startListeners();
    }

    createKeyboardController() {
        this.#keydownHandler = this.onKeydown.bind(this);

        this.#keyboardController = new AbstractController(
            [document],
            [
                {
                    events: [eventsForListening.KEYDOWN],
                    functionForEvents: this.#keydownHandler
                }
            ]
        );

        this.#keyboardController.startListeners();
    }

    onKeydown(event) {
        if (
            event.keyCode !== +keydownKeyCodes.enter
            && event.keyCode !== +keydownKeyCodes.space
        ) return;

        if (event.keyCode === +keydownKeyCodes.space && this.#pauseEnabled) {
            switch (this.#viewController.activeScreenName) {
                case screenNames.GAME:
                    // console.log('onKeydown space GAME_PAGE');
                    this.toPauseGame();

                    break;

                case screenNames.PAUSE:
                    // console.log('onKeydown space PAUSE_PAGE');
                    this.toContinueGame();

                    break;
                default:
                    break;
            }
        }
    }

    getGameCounter() {
        this.#gameCounterWrapper = document.getElementById('beforeStartCounter');
        this.#gameCounterEl = this.#gameCounterWrapper.querySelector('.value');
    }

    getAudio() {
        this.#audioEl = document.getElementById('audio');
        this.#audioToggleEl = document.getElementById('toggleAudioButton');
    }

    async toInitGame() {
        if (this.#htmlReady && this.#authController.userLoginChecked) {
            await this.initGame();
        }
    }

    async initGame() {
        if (GAME_BLOCKED) return;

        if (!this.gameModel || !this.gameController) {
            this.gameModel = new GameModel();
            this.gameController = new GameController(this.gameModel);
        }

        await this.getLevelConfig();
        this.gameModel.init();
    }

    onButtonClick(event) {
        event.stopPropagation();
        event.preventDefault();

        const { currentTarget: buttonEl } = event;

        const eventName = buttonEl.dataset.event;
        const screenName = buttonEl.dataset.screen;
        const isCloseScreen = buttonEl.classList.contains('js-close-screen');

        if (eventName && this[eventName]) this[eventName]();

        if (screenName) {
            this.#viewController.setActiveScreen(screenName);
            Analytics.screen = screenName;
            setTimeout(() => {
                this.#formsController.resetForms();
            }, 500);
        }

        if (isCloseScreen) {
            this.#viewController.showPrevScreen();
        }

        console.log(
            'onButtonClick',
            'eventName',
            eventName,
            'screenName',
            screenName
        );
        document.activeElement.blur();
    }

    // eslint-disable-next-line class-methods-use-this
    busColorSelect() {
        this.toStartGame();
    }

    loadDone() {
        this.#preloaderEl.classList.add(this.#hideClassName);

        setTimeout(() => {
            this.#viewController.setActiveScreen(this.#initialActiveScreen);
            Analytics.screen = this.#initialActiveScreen;
        }, 200);

        setTimeout(() => {
            this.#preloaderEl.remove();

            if (
                (this.#initialActiveScreen === screenNames.SCORING
                    || this.#initialActiveScreen === screenNames.WINNERS)
                && !this.#viewController.isPt
            ) {
                this.#finishFlagView.show();
            }
        }, 1000);
    }

    async getLevelConfig() {
        let config;

        if (this.#authController.isGuest) {
            console.log('IS_GUEST');
            config = generateLevelLootableObjects();
            this.#gameSessionId = null;
        } else {
            console.log('IS_REGISTERED');
            const response = await this.#apiController.fetchLevelConfig();
            const data = response.data[0];

            this.#gameSessionId = data.game.id;
            config = data.game.game_data;
        }

        this.gameModel.setLevelConfig(config);

        return config;
    }

    toStartGame() {
        // console.log('toStartGame');

        // this.gameModel.updateGameSizes();
        this.#viewController.setActiveScreen(screenNames.GAME);
        setTimeout(this.toStartGameModel.bind(this), 300);
    }

    startGame() {
        this.gameModel.play();
        this.gameController.startListeners();

        if (!this.#audioPausedByUser) {
            this.playAudio();
        }
    }

    async toStartGameModel() {
        // await this.getLevelConfig();

        // this.gameModel.init();
        let seconds = gameSettings.secondsBeforeStart;
        let currentTime = new Date();

        this.#gameCounterEl.innerHTML = seconds;
        this.#gameCounterWrapper.classList.remove(this.#hideClassName);

        const update = () => {
            const newTime = new Date();

            if (newTime - currentTime > 1000) {
                seconds -= 1;
                currentTime = newTime;

                if (seconds < 0) {
                    this.#gameCounterWrapper.classList.add(this.#hideClassName);
                    this.startGame();

                    return;
                }
                this.#gameCounterEl.innerHTML = seconds;
            }

            if (!this.#paused) requestAnimationFrame(update);
        };

        update();
    }

    toPauseGame() {
        console.log('toPauseGame');
        this.pauseAudio();
        // this.setActivePageName(pageNames.PAUSE_PAGE);
        this.#paused = true;
        this.#viewController.showPauseScreen();
        // this.#headerEl.classList.add(this.#headerInPauseClass);

        this.gameModel.pause();
        this.gameController.stopListeners();
    }

    async toRestartGame() {
        const restartButtons = Array.from(
            document.querySelectorAll('.js-game-restart-button')
        );

        restartButtons.forEach((button) => {
            button.classList.add('loading');
        });

        await waitForTimeoutPromise(200);

        await this.toInitGame();

        this.#audioEl.currentTime = 0;
        this.#finishFlagView.hide();
        this.#viewController.setActiveScreen(screenNames.GAME);

        restartButtons.forEach((button) => {
            button.classList.remove('loading');
        });

        setTimeout(() => {
            this.#paused = false;
            this.toStartGameModel();
        }, 300);
    }

    toContinueGame() {
        console.log('toContinueGame');
        this.#viewController.hidePauseScreen();
        this.#paused = false;

        this.startGame();
    }

    async testLeaderboard(userId = 62) {
        const leaderboardResponse = await this.#apiController.fetchLeaderboard();

        const leaderboarddata = leaderboardResponse.data[0][0];

        this.#leaderboard.fillWithData(leaderboarddata);
        this.#leaderboard.showResultById(userId);

        this.#viewController.setActiveScreen(screenNames.RESULTS);
    }

    async uploadResultAndUpdateLayout({ time, logs }) {
        const timeStart = Date.now();

        const resultResponse = await this.#apiController.uploadResult({
            id: this.#gameSessionId,
            score: time,
            logs: JSON.stringify(logs)
        });

        console.log(resultResponse);

        const leaderboardResponse = await this.#apiController.fetchLeaderboard();

        console.log(leaderboardResponse);

        const leaderboarddata = leaderboardResponse.data[0][0];

        const userId = resultResponse.data[0].game.user_id;

        console.log(userId);

        this.#leaderboard.fillWithData(leaderboarddata);
        this.#leaderboard.showResultById(userId);

        const timeEnd = Date.now();

        return timeEnd - timeStart;
    }

    async handleLevelComplete({ score, time, logs }) {
        if (GAME_BLOCKED) return;

        this.#finishFlagView.show(this.#viewController.isPt);
        this.#viewController.updateResultTime(time);
        this.gameController.stopListeners();

        let timeForRequest = 0;

        if (this.#gameSessionId && !GAME_IN_DEMO_MODE) {
            timeForRequest = await this.uploadResultAndUpdateLayout({
                score,
                time,
                logs
            });
        }

        const timeout = Math.max(
            gameSettings.beforeFinishDelay - timeForRequest,
            0
        );

        setTimeout(() => {
            this.showFinishPage();
            this.gameModel.stopGame();
        }, timeout);

        if (this.#viewController.isPt) {
            setTimeout(() => {
                this.#finishFlagView.hide();
            }, 3000);
        }
    }

    async showFinishPage() {
        console.log('showFinishPage');
        this.pauseAudio();
        this.#viewController.setActiveScreen(screenNames.FINISH);

        this.#finishScreenTimeout = setTimeout(() => {
            this.showResults();
        }, gameSettings.finishScreenDuration);
    }

    showResults() {
        clearTimeout(this.#finishScreenTimeout);
        this.#finishScreenTimeout = null;
        this.#viewController.setActiveScreen(screenNames.RESULTS);
    }

    toggleAudio() {
        if (
            this.#viewController.activeScreenName !== screenNames.GAME
            || this.gameModel.gameStatus !== gameStatuses.PLAY
        ) return;

        if (this.#audioEl.paused) {
            this.playAudio();
            this.#audioToggleEl.classList.remove('audio-off');
            this.#audioPausedByUser = false;
        } else {
            this.pauseAudio();
            this.#audioToggleEl.classList.add('audio-off');
            this.#audioPausedByUser = true;
        }
    }

    playAudio() {
        this.#audioEl.play();
    }

    pauseAudio() {
        this.#audioEl.pause();
    }
}
